import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { COMPARE_ROWS } from './data';

const CompareTable = () => (
  <section className={`${p.section} ${p.reveal}`}>
    <div className={p.head}>
      <div className={p.badge}>COMPARE</div>
      <h2 className={p.title}>기존 방식과 BNPL의 차이를 확인해보세요.</h2>
      <p className={p.lead}>같은 매출로도 가능한 조건이 달라집니다.</p>
    </div>

    <div className={p.table}>
      <div className={`${p.tRow} ${p.tHead}`}>
        <div>비교 항목</div>
        <div>기존 방식</div>
        <div className={p.tHeadOffer}>오퍼그룹</div>
      </div>

      {COMPARE_ROWS.map((row) => (
        // data-label 은 표가 1열로 접히는 모바일에서 열 제목 대신 쓰인다.
        <div className={p.tRow} key={row.label}>
          <div className={p.tLabel}>{row.label}</div>
          <div className={p.tLegacy} data-label="기존 방식">
            {row.legacy}
          </div>
          <div className={p.tOffer} data-label="오퍼그룹">
            {row.offer}
          </div>
        </div>
      ))}
    </div>

    <div className={p.note}>* 실제 조건은 업종·매출 구조와 심사 결과에 따라 달라집니다.</div>
  </section>
);

export default CompareTable;
